import { Component, Input } from '@angular/core';

export type DocCalloutVariant = 'info' | 'warning' | 'tip';

@Component({
  selector: 'app-doc-callout',
  templateUrl: './doc-callout.component.html',
  styleUrls: ['./doc-callout.component.scss'],
})
export class DocCalloutComponent {
  @Input() variant: DocCalloutVariant = 'info';
}
